<template>
  <el-container class="home-wrap">
    <!-- 邮箱到期退出 -->
    <el-header style="padding:0;height:20%;margin-bottom: 20px;">
      <div class="home-header-box flex-row-between" v-loading="isloading">
        <div class="flex-row-start" style="align-items:start;">
          <img :src="$Image('head3.png')" alt="">
          <div class="home-header-text">
            <div style="font-size:20px">{{EmailUser}}</div>
            <div class="update-time">{{$t('Valid until')}} {{expireTime}}</div>
          </div>
        </div>
        <el-button @click="Update" round class="normalBtn normalBtn_right" style="margin-left:14px;width:180px;height:40px;font-size:13px">{{$t('Update subscription')}}  </el-button>
      </div>
    </el-header>
    <!-- kid's And Account -->
    <el-main>
      <div class="flex-row-between home-main-box">
        <!-- kid's-->
        <div class="home-main-left" v-loading="isloading">
          <div class="flex-row-between main-left-header">
            <div>{{$t('kids equipment')}}</div>
          </div>
          <div class="full_content full_content_scree">
            <div v-if="allKids.length > 0" class="kids-content">
              <div v-for="item in allKids" :key="item.value" class="flex-row-between kids-contents">
                <img :src="$Image(item.userinfo.IsBoy === false ? 'head2_s.png' : 'head1_s.png')" alt="">
                <div class="home-kids-text">
                  <div style="color: #333333;font-size: 18px;">{{item.userinfo.NickName}}</div>
                  <div class="kids-time"> {{item.model}} </div>
                </div>
                <el-button @click="Disconnect(item.id)" round class="normalBtn" style="margin-left:14px;width:132px;height:40px;">{{$t('Disconnect')}}
                </el-button>
              </div>
            </div>
            <div v-else class="flex-col-center" style="padding: 8%">
              <div><img :src="$Image('nodata.png')" alt=""></div>
              <div class="nodata-display">{{$t("No found Kid Device")}}</div>
              <el-button @click="ConnectDevice" round class="normalBtn" style="margin-top:34px;width:166px;height:40px;">{{$t('Connect Device')}}
                </el-button>
            </div>
          </div>
        </div>
        <!--  Account  -->
        <div class="home-main-right" v-loading="isloading">
          <div class="main-right-header">{{$t('My Account')}}</div>
          <div class="full_content">
            <div class="flex-row-between MyAccount">
              <div class="flex-col-between My-All" @click="Signout">
                <img :src="$Image('ico_my1.png')" alt="">
                <div class="MyAccount-text">{{$t('Sign out')}}</div>
              </div>
              <div class="flex-col-between My-All" @click="CancelAccount">
                <img :src="$Image('ico_my2.png')" alt="">
                <div class="MyAccount-text">{{$t('Cancel account')}}</div>
              </div>
              <div class="flex-col-between My-All" @click="About">
                <img :src="$Image('ico_my3.png')" alt="">
                <div class="MyAccount-text">{{$t('About')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <!-- 解绑单个kids 弹框 -->
    <el-dialog
      :visible.sync="showDialog"
      title="Disconnect"
      :width="'40%'"
      :show-close = 'false'
      class="dialog-disconnect"
      style="border-radius: 20px;"
      center>
      <div class="flex-col-center demo--dialog-body"><span>{{$t('You will not be able to receive device status after disconnection. Are you sure you want to disconnect ?')}}</span></div>
      <span slot="footer" class="dialog-footer demo-dialog-footer">
        <el-button class="delete-account-button" size="medium" round @click="showDialog = false">{{$t('No')}}</el-button>
        <el-button class="delete-account-button" type="primary" round size="medium" @click="DisconnectDialog">{{$t('Yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- 退出登录 弹框 -->
    <el-dialog
      :visible.sync="SignoutShowDialog"
      title="Tips"
      :show-close = 'false'
      class="dialog-disconnect"
      style="border-radius: 20px;"
      center>
      <div class="flex-col-center demo--dialog-body"><span>{{$t('Are you sure you want to exit ?')}}</span></div>
      <span slot="footer" class="dialog-footer demo-dialog-footer">
        <el-button class="delete-account-button" size="medium" round @click="SignoutShowDialog = false">{{$t('No')}}</el-button>
        <el-button class="delete-account-button" type="primary" round size="medium" @click="SignoutDialog">{{$t('Yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- 解除所有设备 -->
    <el-dialog
      :visible.sync="CancelAccountShowDialog"
      title="Cancel account"
      :show-close = 'false'
      class="dialog-disconnect"
      style="border-radius: 20px;"
      center>
      <div class="flex-col-center demo--dialog-body"><span>{{$t('Warning: after the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?')}}</span></div>
      <span slot="footer" class="dialog-footer demo-dialog-footer">
        <el-button class="delete-account-button" size="medium" round @click="CancelAccountShowDialog = false">{{$t('No')}}</el-button>
        <el-button class="delete-account-button" type="primary" round size="medium" @click="CancelAccountDialog">{{$t('Yes')}}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import * as Mutations from '../store/mutations'
export default {
  name: 'My',
  props: ['userid', 'device'],
  inject: ['rootMenu'],
  data () {
    return {
      isloading: false,
      isRefresh: true,
      currentUser: false,
      allKids: [],
      EmailUser: '',
      expireTime: '',
      showDialog: false,
      SignoutShowDialog: false,
      CancelAccountShowDialog: false,
      unbindid: '',
      deviceid: '',
      connectDev: true
    }
  },
  methods: {
    ConnectDevice () {
      // this.connectDev = true
      // this.rootMenu.$emit('connectDevice', this.connectDev)
      // console.log('11111111')
      this.$router.push({ path: `/User/${this.userid}/${this.device}/Home` })
    },
    async getMyKids () {
      this.isloading = true
      try {
        const userInfo = await this.$http.get('MDM/GetUserInfo').catch((e) => {
          console.log('MDM/GetUserInfo', e)
        })
        this.allKids = []
        this.EmailUser = userInfo.data.email
        this.expireTime = this.dateFormatter(userInfo.data.devices[0].expire)
        userInfo.data.devices.map((c) => {
          c.userinfo = JSON.parse(c.userinfo)
          this.allKids.push(c)
        })
        console.log(this.allKids)
      } catch (error) {
        console.log(error)
        this.$http.get('MDM/EndGetStatus')
        // this.$router.push('/')
      }
      this.isloading = false
    },
    Update () {
      this.$router.push({ path: `/User/${this.userid}/${this.device}/Buy` })
    },
    // 设备解绑
    Disconnect (id) {
      console.log(id)
      this.showDialog = true
      this.unbindid = id
      this.deviceid = id
    },
    // 解绑弹框
    async DisconnectDialog () {
      this.showDialog = false
      try {
        const result = await this.$http.get('MDM/Device/Unbind', {
          params: {
            id: this.deviceid
          }
        })
        console.log(result)
        if (result.statusText === 'OK') {
          this.rootMenu.$emit('onUnbind', this.unbindid)
        }
        // this.$router.push(`/User/${this.$route.params.userid}`)
      } catch (error) {
        console.log(error)
      }
    },
    SignoutDialog () {
      this.SignoutShowDialog = false
      sessionStorage.removeItem('localToken')
      sessionStorage.removeItem('tokenDate')
      sessionStorage.removeItem('Email')
      sessionStorage.removeItem('routerName')
      sessionStorage.removeItem('userID')
      this.$http.get('MDM/EndGetStatus')
      this.$store.commit(Mutations.logout)
      this.$router.push('/')
    },
    Signout () {
      this.SignoutShowDialog = true
    },
    CancelAccountDialog () {
      this.CancelAccountShowDialog = false
      this.allKids.map(async (c) => {
        console.log(c.id)
        const result = await this.$http.get('MDM/Device/Unbind', {
          params: {
            id: c.id
          }
        })
        console.log(result)
        this.SignoutDialog()
        this.$router.push('/')
      })
    },
    CancelAccount () {
      this.CancelAccountShowDialog = true
    },
    About () {
      this.$router.push({ path: `/User/${this.userid}/${this.device}/About` })
    },
    dateFormatter: function (aDate) {
      return this.$Formatter.date(aDate * 1000)
    }
  },
  mounted () {
    this.getMyKids()
  },
  created () {
  },
  watch: {
    '$route' (to, from) {
      if (to.name === from.name) {
        this.getMyKids()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-wrap{
  // padding:40px 40px 0 40px;
  width: 100%;
  .home-header-box{
  width: 100%;
  padding:2%;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  .home-header-text{
    text-align:left;
    font-size:18px;
    margin-left:30px;
    .update-time{
      margin-top:15px;
      font-size:16px;
      color:#888888;
    }
  }
}
}
.full_content {
  width: 100%;
}
.home-main-box{
  // padding-top:2%;
  box-sizing: border-box;
  flex-wrap: wrap;
  height: 100%;
  .home-main-left{
    width: 49%;
    height: 95%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    overflow: hidden;
    .full_content_scree{
      height: 80%;
      overflow-y: scroll;
      &::-webkit-scrollbar{
        display: none;
      }
    }
    .main-left-header{
      height:69px;
      padding:0 25px;
      border-bottom:1px solid #e5e5e5;
      color:#333333;
      font-size:20px;
    }
  }
  .home-main-right{
    width: 49%;
    height: 95%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .main-right-header{
      height:69px;
      line-height: 69px;
      color:#333333;
      font-size:20px;
      text-align:left;
      padding:0 25px;
      border-bottom:1px solid #e5e5e5;
    }
  }
}
.kids-content{
  padding:0 30px;
  // overflow-y: scroll;
}
.kids-contents{
  border-bottom:1px solid #e5e5e5;
  padding: 20px;
}
.home-kids-text{
  text-align: left;
  width: 50%;
}
.kids-time{
  padding-top: 8px;
  font-size: 16px;
  color: #888888;
}
.MyAccount{
  padding: 70px 180px 70px 60px;
}
.MyAccount-text{
  font-size: 20px;line-height: 35px;color: #333333;margin-top: 20px;
}
.My-All:hover .MyAccount-text{
  color: #2bcf88;
}
.My-All{
  cursor:pointer;
}
@media (min-width: 1024px){
  .home-wrap{
    height: 90%;
  }
}
@media (max-width: 1024px){
  .home-main-box {
    flex-flow: column nowrap;
  }
  .home-main-box .home-main-left {
    width: 100%;
    margin-bottom: 40px;
    margin-top: 30px;
  }
  .home-main-box .home-main-right {
    width: 100%;
  }
}
@media (max-width: 768px){
  .home-wrap .home-header-box {
    flex-flow: column nowrap;
    align-items: flex-start;
    .normalBtn_right {
      margin-left: 65% !important;
    }
  }
}
@media (max-width: 600px){
  .home-wrap .home-header-box {
    .normalBtn_right {
      margin-left: 58% !important;
    }
  }
}
@media (max-width: 485px){
  .home-wrap .home-header-box {
    .normalBtn_right {
      margin-left: 50% !important;
    }
  }
}
@media (max-width: 414px){
  .MyAccount {
    padding: 70px 20px;
  }
  .kids-content {
    padding: 0 10px;
  }
  .home-wrap .home-header-box {
    .normalBtn_right {
      margin-left: 38% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/My.vue